import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _editorNames;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Button, Modal, Text } from "@nextui-org/react";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { CertificationEditor, ContactInfoEditor, EducationEditor, List, SkillsEditor, TextField, WorkExperienceEditor } from "../components/resume/editor";
import { Editor } from "../types";

var noop = function noop() {
  return;
};

var editorNames = (_editorNames = {}, _defineProperty(_editorNames, Editor.Certifications, "Certifications"), _defineProperty(_editorNames, Editor.ContactInfo, "Contact Info"), _defineProperty(_editorNames, Editor.Education, "Education"), _defineProperty(_editorNames, Editor.Highlights, "Highlights"), _defineProperty(_editorNames, Editor.Intro, "Introduction"), _defineProperty(_editorNames, Editor.Skills, "Skills"), _defineProperty(_editorNames, Editor.WorkExperience, "Work Experience"), _editorNames);
export var useEditor = function useEditor(resumeData, onChange) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEditing = _useState2[0],
      setIsEditing = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      currentEditor = _useState4[0],
      setCurrentEditor = _useState4[1]; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      pendingChanges = _useState6[0],
      setPendingChanges = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      hasPendingChanges = _useState8[0],
      setHasPendingChanges = _useState8[1]; // use a ref to avoid excessive re-rendering


  var validationFunction = useRef();
  var setValidateFunction = useCallback(function (fn) {
    validationFunction.current = fn;
  }, []);
  var openEditor = useCallback(function (which) {
    setValidateFunction(undefined);
    setIsEditing(true);
    setCurrentEditor(which);
  }, [setValidateFunction]);
  var validate = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var validateFn, validationResult;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            validateFn = validationFunction.current;

            if (validateFn) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", true);

          case 3:
            _context.next = 5;
            return validateFn();

          case 5:
            validationResult = _context.sent;

            if (!(typeof validationResult === "boolean" && !validationResult)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", false);

          case 8:
            if (!(Array.isArray(validationResult) && validationResult.length)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", validationResult);

          case 10:
            if (!Object.keys(validationResult).length) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", Object.values(validationResult));

          case 12:
            return _context.abrupt("return", true);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);
  var onSectionChange = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(section, newValue) {
      var valueOnly,
          diffs,
          isArray,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              valueOnly = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;

              if (!(!onChange || !isEditing)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              if (valueOnly) {
                diffs = _defineProperty({}, section, newValue);
              } else {
                isArray = Array.isArray(newValue);

                if (isArray) {
                  diffs = _defineProperty({}, section, _toConsumableArray(newValue));
                } else {
                  diffs = _defineProperty({}, section, _objectSpread({}, newValue));
                }
              }

              setPendingChanges(function (currentChanges) {
                return _objectSpread(_objectSpread({}, currentChanges), diffs);
              });
              setHasPendingChanges(true);
              console.log({
                diffs: diffs
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [isEditing, onChange]);
  var sectionHandlers = useMemo(function () {
    var _ref3;

    return _ref3 = {}, _defineProperty(_ref3, Editor.Certifications, function (changes) {
      return onSectionChange("certifications", changes);
    }), _defineProperty(_ref3, Editor.ContactInfo, function (changes) {
      return onSectionChange("contact_info", changes);
    }), _defineProperty(_ref3, Editor.Education, function (changes) {
      return onSectionChange("education", changes);
    }), _defineProperty(_ref3, Editor.Highlights, function (changes) {
      return onSectionChange("highlights", changes);
    }), _defineProperty(_ref3, Editor.Intro, function (changes) {
      return onSectionChange("intro", changes, true);
    }), _defineProperty(_ref3, Editor.Skills, function (changes) {
      return onSectionChange("skills", changes);
    }), _defineProperty(_ref3, Editor.WorkExperience, function (changes) {
      return onSectionChange("work_experience", changes);
    }), _ref3;
  }, [onSectionChange]);
  var editor;

  switch (currentEditor) {
    case Editor.ContactInfo:
      editor = /*#__PURE__*/React.createElement(ContactInfoEditor, {
        contact_info: resumeData === null || resumeData === void 0 ? void 0 : resumeData.contact_info,
        onValueChanged: sectionHandlers["contact-info"],
        setValidateFunction: setValidateFunction
      });
      break;

    case Editor.Highlights:
      editor = /*#__PURE__*/React.createElement(List, {
        input: TextField,
        inputProps: {
          placeholder: "Highlight"
        },
        values: (resumeData === null || resumeData === void 0 ? void 0 : resumeData.highlights) || [],
        onValueAdded: noop,
        onValueChanged: noop,
        onValuesChanged: sectionHandlers.highlights
      });
      break;

    case Editor.Skills:
      editor = /*#__PURE__*/React.createElement(SkillsEditor, {
        onValueChanged: sectionHandlers.skills // skill_groups={resumeData?.skill_groups ?? []}
        ,
        skills: resumeData === null || resumeData === void 0 ? void 0 : resumeData.skills
      });
      break;

    case Editor.Intro:
      editor = /*#__PURE__*/React.createElement(TextField, {
        textarea: true,
        fullWidth: true,
        initialValue: resumeData === null || resumeData === void 0 ? void 0 : resumeData.intro,
        onValueChanged: sectionHandlers.intro,
        setValidateFunction: setValidateFunction
      });
      break;

    case Editor.WorkExperience:
      editor = /*#__PURE__*/React.createElement(WorkExperienceEditor, {
        work_experience: resumeData === null || resumeData === void 0 ? void 0 : resumeData.work_experience,
        onValueChanged: sectionHandlers["work-experience"],
        setValidateFunction: setValidateFunction
      });
      break;

    case Editor.Education:
      editor = /*#__PURE__*/React.createElement(EducationEditor, {
        education: resumeData === null || resumeData === void 0 ? void 0 : resumeData.education,
        onValueChanged: sectionHandlers["education"],
        setValidateFunction: setValidateFunction
      });
      break;

    case Editor.Certifications:
      editor = /*#__PURE__*/React.createElement(CertificationEditor, {
        certifications: resumeData === null || resumeData === void 0 ? void 0 : resumeData.certifications,
        onValueChanged: sectionHandlers["certifications"],
        setValidateFunction: setValidateFunction
      });
  }

  var closeModal = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!hasPendingChanges) {
              _context3.next = 4;
              break;
            }

            if (confirm("Are you sure you want to discard your changes?")) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return");

          case 3:
            setHasPendingChanges(false);

          case 4:
            setIsEditing(false);
            setCurrentEditor(undefined);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [hasPendingChanges]);
  var saveAndCloseModal = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var validationResult, newData;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!hasPendingChanges) {
              _context4.next = 9;
              break;
            }

            _context4.next = 3;
            return validate();

          case 3:
            validationResult = _context4.sent;

            if (!(validationResult !== true)) {
              _context4.next = 7;
              break;
            }

            if (confirm(validationResult === false ? "There are validation errors. Do you want to save anyway?" : "There are validation errors:\n".concat(validationResult.join("\n"), "\n\nDo you want to save anyway?"))) {
              _context4.next = 7;
              break;
            }

            return _context4.abrupt("return");

          case 7:
            if (onChange) {
              newData = _objectSpread(_objectSpread({}, resumeData), pendingChanges);
              onChange(newData, pendingChanges);
            }

            setHasPendingChanges(false);

          case 9:
            setIsEditing(false);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [hasPendingChanges, onChange, pendingChanges, resumeData, validate]);
  var modal = /*#__PURE__*/React.createElement(Modal, {
    open: isEditing,
    blur: true,
    closeButton: true,
    onClose: closeModal,
    scroll: true,
    width: "80%"
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(Text, {
    id: "modal-title",
    size: 18
  }, "Editing", " ", /*#__PURE__*/React.createElement(Text, {
    b: true,
    size: 18
  }, editorNames[currentEditor]))), /*#__PURE__*/React.createElement(Modal.Body, null, editor), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    auto: true,
    flat: true,
    color: "error",
    onClick: closeModal
  }, "Close"), /*#__PURE__*/React.createElement(Button, {
    auto: true,
    onClick: saveAndCloseModal
  }, "Save")));
  return {
    container: modal,
    openEditor: openEditor,
    closeModal: closeModal,
    saveAndCloseModal: saveAndCloseModal
  };
};